import { del } from "../../../utils/axios-config";
import { ENROLLMENTS } from "../../../utils/constants";

export const deleteEnrollment = async (id: string) => await del<any, boolean>(ENROLLMENTS+`/${id}`, {});